import React from 'react';
import HomeThreeMain from './HomeThreeMain';
import HeaderThree from '../../components/Header/HeaderThree';
import FooterTwo from '../../components/Footer/FooterTwo';

const HomeThreeOnePage = () => {
  return (
    <>
      <HeaderThree isOnePage />

      <HomeThreeMain />

      <FooterTwo />
    </>
  );
};

export default HomeThreeOnePage;
